import { useApi, useMessage } from 'app/context';
import { useCallback, useEffect, useState } from 'react';
import { IReportSchema } from 'generated/axios';
import { buildErrorMessage, ROUTES } from 'app/utils';
import { t } from 'i18next';
import { useNavigate } from 'react-router-dom';

export const usePatientReportList = (id: string) => {
  const { reportApi } = useApi();
  const { error, success } = useMessage();
  const navigate = useNavigate();

  const [list, setList] = useState<IReportSchema[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [count, setCount] = useState<number>(0);

  //search filter
  const [filter, setFilter] = useState<string>();

  const handleFilter = (newFilter?: string) => {
    setFilter(newFilter);
  };

  const get = useCallback(() => {
    setLoading(true);
    reportApi
      .webListReportsByPatientID(id, filter)
      .then((resp) => {
        if (resp.status >= 400) {
          return Promise.reject(resp);
        }
        setList(resp.data);
        setCount(resp.data.length);
      })
      .catch((err) => {
        error({ message: buildErrorMessage(err) });
      })
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportApi, id, filter]);

  const create = useCallback(() => {
    setLoading(true);
    reportApi
      .webCreateReport({ patient_id: id })
      .then((resp) => {
        if (resp.status >= 400) {
          return Promise.reject(resp);
        }
        success({ message: t('report.createSuccess') as string });
        navigate(ROUTES.reports + '/' + resp.data.id);
      })
      .catch((err) => {
        error({ message: buildErrorMessage(err) });
      })
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportApi, id]);

  useEffect(() => {
    get();
  }, [get]);

  return { list, loading, count, create, filter, handleFilter };
};
